import React from "react";
import { Link } from "react-router-dom";
import "./GridSection.css";

const gridItems = [
  {
    title: "Race",
    image: "./gallery/VLD_8834.jpg",
    link: "/about",
  },
  {
    title: "Results",
    image: "./gallery/VLD_10016.jpg",
    link: "/results",
  },
];

const GridSection = () => {
  return (
    <div className="grid-container">
      {gridItems.map((item, index) => (
        <div
          className="grid-item"
          key={index}
          style={{
            backgroundImage: `url(${item.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="overlay">
            <h2>{item.title}</h2>
            <Link
              to={item.link}
              className="details-link"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              DETAILS
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
};

export default GridSection;
